module.exports = __webpack_public_path__ + "static/media/qrcode.0e28134b.png";